import { useIsMobileApp } from './useIsMobileApp.ts';

export const useEmitClickButton = () => {
  const { isAndroidApp, postMessage } = useIsMobileApp();
  return () => {
    if (isAndroidApp) {
      postMessage('clickButton', {});
    }
  };
};
